import React from 'react';
import { Upload } from 'antd';
import AntdImgCrop from 'antd-img-crop';

function FilePreviewUploader({ maxItems, fileList, setFileList, aspect }) {
	const onChange = ({ fileList: newFileList }) => {
		setFileList(newFileList);
	};
	const onPreview = async (file) => {
		let src = file.url;
		if (!src) {
			src = await new Promise((resolve) => {
				const reader = new FileReader();
				reader.readAsDataURL(file.originFileObj);
				reader.onload = () => resolve(reader.result);
			});
		}
		const image = new Image();
		image.src = src;
		const imgWindow = window.open(src);
		imgWindow?.document.write(image.outerHTML);
	};
	return (
		<AntdImgCrop rotationSlider aspect={aspect}>
			<Upload action={`${BASEURL}/upload`} listType='picture-card' fileList={fileList} onChange={onChange} onPreview={onPreview}>
				{fileList.length < maxItems && '+ Upload'}
			</Upload>
		</AntdImgCrop>
	);
}

export default FilePreviewUploader;
